import React from 'react';
import { createGlobalStyle, css } from 'styled-components';

const path = 'https://jsapi.cdn.level.travel/fonts';

const RawGlobalStyles = createGlobalStyle<{ $mode: 'light' | 'dark' }>`
  @font-face {
    font-family: 'Backpack';
    src: url(${path}/backpack/Backpack-Regular.woff2) format('woff2'),
         url(${path}/backpack/Backpack-Regular.woff) format('woff');
  }
  
  @font-face {
    font-family: 'Backpack';
    src: url(${path}/backpack/Backpack-Bold.woff2) format('woff2'),
         url(${path}/backpack/Backpack-Bold.woff) format('woff');
    font-weight: bold;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 13px;
    font-family: 'Backpack';
    transition: filter 0.3s ease;

    ${({ $mode }) =>
      $mode === 'dark' &&
      css`
        filter: invert(1) hue-rotate(180deg) brightness(1.2);
      `}
  }

  img {
    ${({ $mode }) =>
      $mode === 'dark' &&
      css`
        filter: invert(1) hue-rotate(180deg);
      `}
  }

  input {
    font-family: 'Backpack';
  }

  ul {
    list-style: none;
  }
`;

export default function GlobalStyles({ theme }: { theme: 'light' | 'dark' }) {
  return <RawGlobalStyles $mode={theme} />;
}
